import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "py-1 text-mild text-size-14 text-weight-500" }, "\n        勤務中\n      ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "py-1 text-mild text-size-14 text-weight-500" }, "\n        未出勤\n      ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "py-1 text-mild text-size-14 text-weight-500" }, "\n        未退勤\n      ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "py-1 text-mild text-size-14 text-weight-500" }, "\n        勤怠変更未申請\n      ", -1)
const _hoisted_6 = {
  key: 4,
  class: "p-3 bg-white text-14 text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ApplicationCard = _resolveComponent("ApplicationCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.doingApplication && !_ctx.notLeavingApplication)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_2,
          _createTextVNode(),
          _createVNode(_component_ApplicationCard, {
            application: _ctx.doingApplication,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clickOrderCard', _ctx.doingApplication.id))),
            class: "mb-2"
          }, null, 8, ["application"])
        ], 64))
      : _createCommentVNode("", true),
    _createTextVNode(),
    (_ctx.notAttendingApplication)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _hoisted_3,
          _createTextVNode(),
          _createVNode(_component_ApplicationCard, {
            application: _ctx.notAttendingApplication,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('clickOrderCard', _ctx.notAttendingApplication.id))),
            class: "mb-2"
          }, null, 8, ["application"])
        ], 64))
      : _createCommentVNode("", true),
    _createTextVNode(),
    (_ctx.notLeavingApplication)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _hoisted_4,
          _createTextVNode(),
          _createVNode(_component_ApplicationCard, {
            application: _ctx.notLeavingApplication,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('clickOrderCard', _ctx.notLeavingApplication.id))),
            class: "mb-2"
          }, null, 8, ["application"])
        ], 64))
      : _createCommentVNode("", true),
    _createTextVNode(),
    (_ctx.attendanceCorrections.length > 0)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
          _hoisted_5,
          _createTextVNode(),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attendanceCorrections, (application) => {
            return (_openBlock(), _createBlock(_component_ApplicationCard, {
              key: application.id,
              application: application,
              onClick: ($event: any) => (_ctx.$emit('clickOrderCard', application.id)),
              class: "mb-2"
            }, null, 8, ["application", "onClick"]))
          }), 128))
        ], 64))
      : _createCommentVNode("", true),
    _createTextVNode(),
    (_ctx.attendanceApplicationCount === 0)
      ? (_openBlock(), _createElementBlock("p", _hoisted_6, "\n      お仕事はありません\n    "))
      : _createCommentVNode("", true)
  ]))
}